var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Apartment",
    transform: "translate(0.002 0.096)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1782",
    "data-name": "Rectangle 1782",
    width: 18,
    height: 18,
    transform: "translate(-0.002 -0.096)",
    fill: "#00286f",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3465",
    "data-name": "Group 3465",
    transform: "translate(0.825 1.354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_737",
    "data-name": "Group 737",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_153655",
    "data-name": "Path 153655",
    d: "M.7,0h.7a.7.7,0,0,1,.7.7V2.1a.7.7,0,0,1-.7.7H.7A.7.7,0,0,1,0,2.1V.7A.7.7,0,0,1,.7,0Z",
    transform: "translate(3.382 12.622)",
    fill: "#002970"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153654",
    "data-name": "Path 153654",
    d: "M.7,0h.7a.7.7,0,0,1,.7.7V2.1a.7.7,0,0,1-.7.7H.7A.7.7,0,0,1,0,2.1V.7A.7.7,0,0,1,.7,0Z",
    transform: "translate(11.096 12.622)",
    fill: "#002970"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_736",
    "data-name": "Group 736"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_296",
    "data-name": "Line 296",
    x2: 2.654,
    transform: "translate(7.403 13.082)",
    fill: "#fff3f4",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_297",
    "data-name": "Line 297",
    x2: 10.224,
    transform: "translate(2.683 11.024)",
    fill: "#fff3f4",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153656",
    "data-name": "Path 153656",
    d: "M2.8,0H9.817a2.8,2.8,0,0,1,2.8,2.8v7.714a2.8,2.8,0,0,1-2.8,2.8H2.8a2.8,2.8,0,0,1-2.8-2.8V2.8A2.8,2.8,0,0,1,2.8,0Z",
    transform: "translate(1.979)",
    fill: "#fff",
    stroke: "#002970",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153653",
    "data-name": "Path 153653",
    d: "M2.8,0H9.817a2.8,2.8,0,0,1,2.8,2.8V7.714H0V2.8A2.8,2.8,0,0,1,2.8,0Z",
    transform: "translate(1.979)",
    fill: "#fff",
    stroke: "#002970",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_298",
    "data-name": "Line 298",
    x2: 2.764,
    transform: "translate(7.184 2.177)",
    fill: "none",
    stroke: "#002970",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7493",
    "data-name": "Path 7493",
    d: "M9.776,25.384a.856.856,0,1,1-.856-.866A.861.861,0,0,1,9.776,25.384Z",
    transform: "translate(-4.217 -15.027)",
    fill: "#002970"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7494",
    "data-name": "Path 7494",
    d: "M25.987,25.384a.856.856,0,1,1-.856-.866A.861.861,0,0,1,25.987,25.384Z",
    transform: "translate(-13.376 -15.027)",
    fill: "#002970"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153642",
    "data-name": "Path 153642",
    d: "M-3.275,5.978V4.356H-1.6",
    transform: "translate(3.275 -1.41)",
    fill: "none",
    stroke: "#002970",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153643",
    "data-name": "Path 153643",
    d: "M-1.653,5.978V4.356H-3.275",
    transform: "translate(18.245 -1.41)",
    fill: "none",
    stroke: "#002970",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.315eb3645ec776fed54c6e020e0613aa.svg";
export { ForwardRef as ReactComponent };